import axiosClient from '../../../api/axiosClient.js';
import { fetchPageData } from '../../../api/utils.js';

export async function getGames() {
  return fetchPageData(`/api/games/games/`);
}

export const gamesQuery = () => {
  return {
    queryKey: ['games'],
    queryFn: async () => getGames(),
    refetchOnWindowFocus: false
  };
};

export async function getClassificationScores({gameId, completed}) {
  return fetchPageData(`/api/classification/scores/${gameId ? `?game=${gameId}` : ''}${completed ? `?completed=true` : ''}`);
}

export const classificationScoresQuery = (gameId, completed) => {
  return {
    queryKey: ['classificationScoresInsights'],
    queryFn: async () => getClassificationScores({gameId, completed}),
    refetchOnWindowFocus: false,
    retry: false,
  }
};

export async function getNormalScores({gameId, completed}) {
  return fetchPageData(`/api/normal/scores/${gameId ? `?game=${gameId}` : ''}${completed ? `?completed=true` : ''}`);
}

export const normalScoresQuery = (gameId, completed) => {
  return {
    queryKey: ['normalScoresInsights'],
    queryFn: async () => getNormalScores({gameId, completed}),
    refetchOnWindowFocus: false,
    retry: false,
  }
};

export async function getPrinciplesScores({gameId, completed}) {
  return fetchPageData(`/api/principles/scores/${gameId ? `?game=${gameId}` : ''}${completed ? `?completed=true` : ''}`);
}

export const principlesScoresQuery = (gameId, completed) => {
  return {
    queryKey: ['principlesScoresInsights'],
    queryFn: async () => getPrinciplesScores({gameId, completed}),
    refetchOnWindowFocus: false,
    retry: false,
  }
};

export async function getBalancedEquationScores({gameId, completed}) {
  return fetchPageData(`/api/equation/scores/${gameId ? `?game=${gameId}` : ''}${completed ? `?completed=true` : ''}`);
}

export const balancedEquationScoresQuery = (gameId, completed) => {
  return {
    queryKey: ['balancedEquationScoresInsights'],
    queryFn: async () => getBalancedEquationScores({gameId, completed}),
    retry: false,
    refetchOnWindowFocus: false
  }
};

export async function getClassificationScoresByQuestion(gameId) {
  return fetchPageData(`/api/classification/scores/by-question/${gameId ? `?game=${gameId}` : ''}`);
}

export async function getNormalScoresByQuestion(gameId) {
  return fetchPageData(`/api/normal/scores/by-question/${gameId ? `?game=${gameId}` : ''}`);
}

export async function getPrinciplesScoresByQuestion(gameId) {
  const response = await axiosClient.get(`/api/principles/scores/principles/${gameId ? `?game=${gameId}` : ''}`);
  return response?.data;
}

export async function getBalancedEquationScoresByQuestion(gameId) {
  return fetchPageData(`/api/equation/scores/by-question/${gameId ? `?game=${gameId}` : ''}`);
}

export async function getEquationScoresInsights({gameId, completed}) {
  return fetchPageData(`/api/equation/scores/insights/${gameId ? `?game=${gameId}` : ''}${completed ? `?completed=true` : ''}`);
}

export async function getPrinciplesScoresPrinciples({gameId, completed}) {
  const response = await axiosClient.get(`/api/principles/scores/principles/${gameId ? `?game=${gameId}` : ''}${completed ? `?completed=true` : ''}`);
  return response?.data;
}

export async function getClassificationScoresInsights({gameId, completed}) {
  return fetchPageData(`/api/classification/scores/insights/${gameId ? `?game=${gameId}` : ''}${completed ? `?completed=true` : ''}`);
}

export async function getNormalScoresInsights({gameId, completed}) {
  return fetchPageData(`/api/normal/scores/insights/${gameId ? `?game=${gameId}` : ''}${completed ? `?completed=true` : ''}`);
}

export async function getScenarioLevels(scenarioId) {
  return fetchPageData(`/api/games/scenario-levels/?scenarios=${scenarioId}`);
}

export async function getCourseMembers() {
  return fetchPageData(`/api/users/course-members/`);
}

export const courseMembersQuery = () => {
  return {
    queryKey: ['courseMembers'],
    queryFn: async () => getCourseMembers(),
    refetchOnWindowFocus: false
  };
};

export async function getClassificationDecisionsInsights({gameId}) {
  const response = await axiosClient.get(`/api/classification/decisions/insights/${gameId}/`);
  return response?.data;
}

export async function getBalancedEquationDecisionsInsights({gameId}) {
  const response = await axiosClient.get(`/api/equation/decisions/insights/${gameId}/`);
  return response?.data;
}

export async function getThePrinciplesDecisionsInsights({gameId}) {
  const response = await axiosClient.get(`/api/principles/decisions/insights/${gameId}/`);
  return response?.data;
}

export async function getItems() {
  return fetchPageData(`/api/games/items/`);
}

export async function getGamesTransactions() {
  return fetchPageData(`/api/games/transactions/`);
}


export async function getNormalDecisionsInsights({gameId}) {
  const response = await axiosClient.get(`/api/normal/decisions/insights/${gameId}`);
  return response?.data;
}

export async function getGamesSessions() {
  return fetchPageData(`/api/games/sessions/`);
}

export const gamesSessionsQuery = () => {
  return {
    queryKey: ['gamesSessionsScores'],
    queryFn: async () => getGamesSessions(),
    refetchOnWindowFocus: false
  };
};

export async function getBalancedEquationDecisions() {
  return fetchPageData('/api/equation/decisions/');
}

export const balancedEquationDecisionsQuery = () => {
  return {
    queryKey: [`balancedEquationDecisionsResponse`],
    queryFn: async () => getBalancedEquationDecisions(),
    refetchOnWindowFocus: false,
    cacheTime: 0
  };
};

export async function getThePrinciplesDecisions() {
  return fetchPageData('/api/principles/decisions/');
}

export const thePrinciplesDecisionsQuery = () => {
  return {
    queryKey: [`thePrinciplesDecisionsResponse`],
    queryFn: async () => getThePrinciplesDecisions(),
    refetchOnWindowFocus: false,
    cacheTime: 0
  };
};